import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import Button from '../common/button/button';
import Form from './conferenciaChecklistForm';
import Select from '../common/form/select';
import Aguardando from '../common/template/aguardando';

import { setModoTela, initForm, setFiltro, getLista, setChecklist } from './conferenciaChecklistActions';
import DateFormat from '../common/dateFormat/DateFormat';
import FormatUtils from '../common/formatUtils/FormatUtils';
import LabelAndInputMask from '../common/form/labelAndInputMask';

class ConferenciaChecklist extends Component {

	state = {
		linhaSelecionada: null,
		conferido: false,
		pesquisar: ''
	}

    componentWillMount() {
		this.props.getLista();
    }

    render() {
        return (
            <div>
				
				<Aguardando aguardando={this.props.aguardando} />

                <Content>
					{this.props.modoTela == 'cadastro' ? (
						<Form />
					) : null}
					{this.props.modoTela == 'lista' ? this.lista() : null}
                </Content>
            </div>
        )
    }

	lista() {
		return (
			<ContentCard>
				<ContentCardBody>					
					<Row>
						<LabelAndInputMask
							label='Data Inicial' placeholder='Informe o período inicial'
							cols='12 6 3 2'
							mask='99/99/9999'
							value={this.props.filtro.data_inicial}
							onChange={(data) => {
								this.props.setFiltro({ ...this.props.filtro, data_inicial: data.target.value });
							}} />

						<LabelAndInputMask
							label='Data Final' placeholder='Informe o período final'
							cols='12 6 3 2'
							mask='99/99/9999'
							value={this.props.filtro.data_final}
							onChange={(data) => {
								this.props.setFiltro({ ...this.props.filtro, data_final: data.target.value });
							}} />

						<Select
							label='Conferido'
							cols='12 6 4 3'
							options={[{ id: '1', valor: 'Sim' }, { id: '2', valor: 'Não' }, { id: '3', valor: 'Ambos' }]}
							value={this.state.conferido == null ? 3 : (this.state.conferido ? 1 : 2)}
							onChange={item => {
								this.setState({ ...this.state, conferido: item == 3 ? null : item == 1 })
							}} />

						<Grid cols='6 6 4 2' style={{ paddingTop: 28 }}>
							<Button
								text='Atualizar'
								type={'primary'}
								icon={'fa fa-plus'}
								event={() => {
									this.props.getLista();
								}} />
						</Grid>
					</Row>

					<input className='form-control'
						 placeholder='Pesquisar'
						 type='text'
						 value={this.state.pesquisar}
						 onChange={e => {
							 this.setState({ ...this.state, pesquisar: e.target.value });
						 }} />
					<Table responsive>
						
							<Tr>
								<Th alignCenter>Data/Hora</Th>
								<Th alignCenter>Checklist</Th>
								<Th alignCenter>Motorista</Th>
								<Th alignCenter>Veículo</Th>
								<Th alignCenter>Viagem</Th>
								<Th alignCenter>Carga</Th>
								<Th alignCenter>Descarga</Th>
								<Th alignCenter>Produto</Th>
								<Th alignCenter>Observação</Th>
								<Th alignCenter>Conferido</Th>
								<Th></Th>
							</Tr>
						
						<TBody>
							{this.props.lista.filter(item => this.state.conferido == null ? true : (this.state.conferido ? item.conferido : !item.conferido)).filter(item => {
									if (this.state.pesquisar
										&& !(`
											${DateFormat.formatarDataHoraSqlParaTela(item.datahora_checklist)}
											${item.nome_checklist}
											${item.nome_motorista}
											${item.placa_veiculo}
											${item.numero_viagem_lancamento}
											${item.viagem_item_carga}
											${item.viagem_item_descarga}
											${item.viagem_item_produto}
											${item.observacao_viagem_item}
										`).toUpperCase().includes(this.state.pesquisar.toUpperCase())) {
										return false;
									}
									return true;
								}).map(item => (
								<Tr key={item.id} className={`${this.state.linhaSelecionada == item.id ? 'hover' : ''}`}
									onClick={() => this.setState({ ...this.state, linhaSelecionada: item.id })}
									onMouseEnter={() => this.setState({ ...this.state, linhaSelecionada: item.id })} >
									<Td alignCenter>{DateFormat.formatarDataHoraSqlParaTela(item.datahora_checklist)}</Td>
									<Td alignCenter>{item.nome_checklist}</Td>
									<Td alignCenter>{item.nome_motorista}</Td>
									<Td alignCenter>{item.placa_veiculo}</Td>
									<Td alignCenter>{item.numero_viagem_lancamento}</Td>
									<Td alignCenter>{item.viagem_item_carga}</Td>
									<Td alignCenter>{item.viagem_item_descarga}</Td>
									<Td alignCenter>{item.viagem_item_produto}</Td>
									<Td alignCenter>{item.observacao_viagem_item}</Td>
									<Td alignCenter>{item.conferido ? 'Sim' : 'Não'}</Td>
									<Td alignRight minWidth={100}>
										<ButtonTable
											type={'primary'}
											icon={'fas fa-eye'}
											visible={true}
											event={() => {
												this.props.setChecklist(item);
											}} />
									</Td>
								</Tr>
							))}
						</TBody>
					</Table>
				</ContentCardBody>
			</ContentCard>
		);
	}


}

const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	modoTela: state.conferenciaChecklist.modoTela,
	aguardando: state.conferenciaChecklist.aguardando,
	lista: state.conferenciaChecklist.lista,
	permissoes: state.usuario.permissoes,
	filtro: state.conferenciaChecklist.filtro
});
const mapDispatchToProps = dispatch => bindActionCreators({setModoTela, initForm, setFiltro, getLista, setChecklist }, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(ConferenciaChecklist);
